<template>
  <board/>
</template>

<script>
import Board from "../../components/dashboard/Board"

export default {
  name: "Dashboard",
  components :{
      Board
  }
};
</script>
